export default "__VITE_ASSET__Hdx72niv__"